import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface UserModel {
    id: number
    username: string
    full_name: string
    password: string
    phone: string
    active: boolean
    email: string
    warehouses?: number[]
    groups?: number[]

    created_by?: UserModel
    updated_by?: UserModel
}

export interface CreateUserRequest {
    full_name: string
    username: string
    password: string
    phone: string
    email: string
    active: boolean
    groups?: number[]
    warehouses?: number[]
}

export interface UpdateUserRequest {
    id?: number
    full_name?: string
    username?: string
    email?: string
    newPassword?: string
    active?: boolean
    groups?: number[]
    phone?: string
    warehouses?: number[]
    default_warehouse?: number
}

const userApi = (apiInstance: AxiosInstance) => {
    const usersList = async ({ warehouse }: { warehouse?: string }): Promise<GenericResponse> => {
        return apiInstance.get(`/parcel-hub-users/get-all-parcel-hub-users?warehouse=${warehouse}`)
    }

    const createUser = async (newUserData: CreateUserRequest): Promise<GenericResponse> => {
        const { groups, warehouses } = newUserData
        delete newUserData["groups"]
        delete newUserData["warehouses"]
        return apiInstance.post(`/parcel-hub-users/create-user`, {
            userData: newUserData,
            groups,
            warehouses
        })
    }

    const updateUser = async (existingUserData: UpdateUserRequest): Promise<GenericResponse> => {
        const { groups, warehouses, id, default_warehouse } = existingUserData
        const userId = id
        const defaultWarehouse = default_warehouse
        delete existingUserData["groups"]
        delete existingUserData["warehouses"]
        delete existingUserData["id"]
        delete existingUserData["default_warehouse"]
        const res: Promise<GenericResponse> = apiInstance.put(`/parcel-hub-users/update-user`, {
            userData: existingUserData,
            userId,
            groups,
            warehouses,
            defaultWarehouse
        })
        return res
    }

    const validateUserIdentity = async (newUserIdentity: string): Promise<GenericResponse> => {
        return apiInstance.post(`/parcel-hub-users/validate-username-or-email`, {
            identity: newUserIdentity
        })
    }

    return {
        usersList,
        createUser,
        updateUser,
        validateUserIdentity
    }
}

export default userApi
